import Model from '../model';
import DocumentModel from './document';

/**
 * Deal Model
 * @property {int} id
 * @property {int} created_by
 * @property {string} name
 * @property {string} dealer_name
 * @property {boolean} is_complete
 * @property {boolean} is_rejected
 * @property __className
 */
export default class DocumentRequestModel extends Model {
  /**
   * DocumentRequestModel Constructor
   * @param deal
   */
  constructor(deal) {
    super(deal);
    this.__className = 'DocumentRequestModel';
  }

  /**
   * A document request will have a maximum of 1 document.
   *
   * @returns {DocumentModel}
   */
  document() {
    if (this.documents && this.documents.length > 0) {
      return new DocumentModel(this.documents[0]);
    }
    return null;
  }

  /**
   * Can the request be rejected?
   *
   * @returns {boolean}
   */
  canBeRejected() {
    return !this.is_complete && !this.is_rejected;
  }

  /**
   * Can the request have an upload made against it?
   *
   * @returns {boolean}
   */
  canBeUploaded() {
    return this.is_rejected === false
      && this.is_complete === false;
  }
}
